module.exports = __webpack_public_path__ + "static/media/sparkol.38839c96.png";